// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Financial Navigation Tabs ── */
.wallet-nav-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.wallet-nav-tab {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.65);
  font-family: 'Inter', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  padding: 9px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.wallet-nav-tab:hover {
  background: rgba(255, 255, 255, 0.09);
  color: #ffffff;
}

.wallet-nav-tab.active {
  background: #3bb3ae;
  border-color: #3bb3ae;
  color: #071414;
  font-weight: 700;
  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.25);
}

.wallet-settings-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 30px;
  background-color: #0e1b1b;
  border-radius: 12px;
  border: 1px solid rgba(90, 175, 154, 0.15);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);
  color: #ffffff;
  max-width: 1200px;
  margin: 0 auto;
}

.wallet-settings-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 20px;
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}

.wallet-title-section {
  flex: 1 1;
  min-width: 280px;
}

.wallet-subtitle {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin: 6px 0 0 0;
}

/* Connect Stripe Button */
.payout-btn-primary {
  background-color: #5AAF9A;
  color: #071414;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.payout-btn-primary:hover:not(:disabled) {
  background-color: #6bc2ad;
  transform: translateY(-1px);
}

.payout-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Financial Cards Grid */
.wallet-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 8px;
}

/* KPI Card Styles */
.kpi-card.glassmorphism {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
}

.kpi-card.glassmorphism:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(90, 175, 154, 0.3);
  transform: translateY(-2px);
}

.kpi-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kpi-card-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
}

.kpi-card-icon-wrapper svg {
  font-size: 20px;
}

.icon-total {
  background-color: rgba(90, 175, 154, 0.15);
  color: #5AAF9A;
}

.icon-escrow {
  background-color: rgba(255, 193, 7, 0.15);
  color: #ffc107;
}

.icon-stripe {
  background-color: rgba(99, 91, 255, 0.15);
  color: #635bff;
}

.icon-affiliate {
  background-color: rgba(156, 39, 176, 0.15);
  color: #ba68c8;
}

.wallet-cards-grid--4 {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.wallet-card-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.wallet-badge-pill {
  font-size: 11px;
  font-weight: 600;
  color: #48d1cc;
  background: rgba(72, 209, 204, 0.08);
  border: 1px solid rgba(72, 209, 204, 0.2);
  padding: 3px 8px;
  border-radius: 12px;
}

.kpi-card-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.kpi-card-value {
  font-size: 26px;
  font-weight: 600;
  color: #ffffff;
}

.kpi-card-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}

.stripe-balance-breakdown {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 8px;
  margin-top: 4px;
}

.stripe-pending {
  color: rgba(255, 255, 255, 0.4);
}

/* Ledger Section */
.ledger-section.glassmorphism {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 24px;
  margin-top: 10px;
}

.ledger-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 12px;
}

.ledger-title {
  font-size: 18px;
  font-weight: 600;
  color: #5AAF9A;
  margin: 0;
}

.ledger-count {
  font-size: 12px;
  background-color: rgba(90, 175, 154, 0.1);
  border: 1px solid rgba(90, 175, 154, 0.2);
  color: #5AAF9A;
  padding: 4px 10px;
  border-radius: 20px;
}

/* Ledger Table */
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.ledger-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
  text-align: left;
}

.ledger-table th {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(90, 175, 154, 0.15);
  background-color: rgba(90, 175, 154, 0.04);
}

.ledger-table td {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

.ledger-table th:first-child,
.ledger-table td:first-child {
  white-space: nowrap;
  width: 120px;
}

.ledger-row {
  transition: background-color 0.2s ease;
}

.ledger-row:hover {
  background-color: rgba(255, 255, 255, 0.02);
}

.ledger-offering-title {
  font-weight: 600;
  color: #ffffff;
}

.ledger-booking-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 2px;
}

/* Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11.5px;
  font-weight: 500;
  text-transform: uppercase;
}

.ledger-status-icon {
  font-size: 13px !important;
}

.status-released {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.2);
}

.status-escrow {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.status-disputed {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.2);
}

.status-refunded {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.status-unpaid {
  background-color: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

/* Countdown Visualizer */
.countdown-container {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffc107;
}

.countdown-icon {
  font-size: 14px !important;
}

.countdown-text {
  font-size: 12px;
  font-weight: 500;
}

/* Pagination */
.ledger-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.pagination-btn {
  background-color: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.4);
}

.pagination-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.pagination-info {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

/* Loader Styles */
.wallet-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  gap: 12px;
}

.loader-spinner {
  color: #5AAF9A !important;
}

.empty-table-row {
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
  padding: 30px !important;
}

.text-success { color: #28a745; }
.text-warning { color: #ffc107; }
.text-danger { color: #dc3545; }
.text-muted { color: rgba(255, 255, 255, 0.6); }
.font-semibold { font-weight: 500; }
.font-bold { font-weight: 700; }

.animate-fade-in {
  animation: fadeIn 0.4s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Earnings Trend SVG Chart */
.earnings-chart-container {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 24px;
  margin-top: 10px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 12px;
}

.chart-title {
  font-size: 18px;
  font-weight: 600;
  color: #5AAF9A;
  margin: 0;
}

.chart-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.empty-chart-state {
  text-align: center;
  padding: 40px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
}

.svg-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  padding-top: 10px;
}

.earnings-svg {
  width: 100%;
  height: auto;
  overflow: visible;
}

.chart-point-group {
  cursor: pointer;
}

.chart-point-group:hover circle:first-child {
  fill: #5AAF9A;
  r: 5;
}

.chart-point-group:hover .point-pulse {
  animation: pulse 1.2s infinite ease-out;
  opacity: 0.4;
}

.chart-point-group:hover .point-tooltip {
  opacity: 1;
}

.point-tooltip {
  font-size: 9px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.chart-axis-label {
  font-size: 9px;
  font-weight: 500;
}

@keyframes pulse {
  0% {
    r: 6;
    opacity: 0.5;
  }
  100% {
    r: 16;
    opacity: 0;
  }
}

/* ── Unified Ledger Type Badges ── */
.ledger-type-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 12px;
  text-transform: uppercase;
}
.type-service {
  color: #48d1cc;
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.25);
}
.type-affiliate {
  color: #ba68c8;
  background: rgba(186, 104, 200, 0.12);
  border: 1px solid rgba(186, 104, 200, 0.25);
}

/* ── Unified Affiliate Tab Styling ── */
.affiliate-unified-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 24px;
  margin-bottom: 24px;
}

.affiliate-avatar-box {
  display: flex;
  align-items: center;
  gap: 16px;
}

.affiliate-avatar-img,
.affiliate-avatar-initials {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.affiliate-avatar-initials {
  background: #3bb3ae;
  color: #071414;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
}

.affiliate-name {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 4px 0;
}

.affiliate-tag {
  font-size: 12px;
  font-weight: 600;
  color: #48d1cc;
  background: rgba(72, 209, 204, 0.1);
  padding: 3px 10px;
  border-radius: 12px;
}

.affiliate-quick-stats {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.affiliate-stat-pill {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.affiliate-stat-pill span {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.affiliate-stat-pill strong {
  font-size: 20px;
  font-weight: 700;
  color: #28a745;
}

/* ── Referral Sharing Boxes ── */
.affiliate-sharing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.affiliate-box {
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.affiliate-box h3 {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.affiliate-box p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 8px 0;
  line-height: 1.5;
}

.affiliate-copy-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.affiliate-input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 14px;
  color: #ffffff;
  font-size: 13px;
  outline: none;
}

.affiliate-copy-btn {
  background: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.affiliate-copy-btn:hover {
  background: #48d1cc;
}

/* ── Unified Payout Note ── */
.affiliate-payout-note {
  padding: 22px;
  background-color: rgba(72, 209, 204, 0.05);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-left: 4px solid #48d1cc;
  border-radius: 12px;
}

.affiliate-payout-note__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.affiliate-payout-note__content h4 {
  font-size: 16px;
  font-weight: 700;
  color: #48d1cc;
  margin: 0 0 6px 0;
}

.affiliate-payout-note__content p {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.55;
  max-width: 680px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/WalletPage/WalletPage.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,eAAe,cAAc,EAAE;AAC/B,cAAc,+BAA+B,EAAE;AAC/C,iBAAiB,gBAAgB,EAAE;AACnC,aAAa,gBAAgB,EAAE;;AAE/B;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,IAAI;AACN;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,IAAI;IACJ,YAAY;EACd;EACA;IACE,KAAK;IACL,UAAU;EACZ;AACF;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,0CAA0C;EAC1C,yCAAyC;EACzC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* ── Financial Navigation Tabs ── */\n.wallet-nav-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.wallet-nav-tab {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.65);\n  font-family: 'Inter', sans-serif;\n  font-size: 13.5px;\n  font-weight: 600;\n  padding: 9px 20px;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.wallet-nav-tab:hover {\n  background: rgba(255, 255, 255, 0.09);\n  color: #ffffff;\n}\n\n.wallet-nav-tab.active {\n  background: #3bb3ae;\n  border-color: #3bb3ae;\n  color: #071414;\n  font-weight: 700;\n  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.25);\n}\n\n.wallet-settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 30px;\n  background-color: #0e1b1b;\n  border-radius: 12px;\n  border: 1px solid rgba(90, 175, 154, 0.15);\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);\n  color: #ffffff;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.wallet-settings-header {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 20px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  width: 100%;\n}\n\n.wallet-title-section {\n  flex: 1;\n  min-width: 280px;\n}\n\n.wallet-subtitle {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  margin: 6px 0 0 0;\n}\n\n/* Connect Stripe Button */\n.payout-btn-primary {\n  background-color: #5AAF9A;\n  color: #071414;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.payout-btn-primary:hover:not(:disabled) {\n  background-color: #6bc2ad;\n  transform: translateY(-1px);\n}\n\n.payout-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Financial Cards Grid */\n.wallet-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 8px;\n}\n\n/* KPI Card Styles */\n.kpi-card.glassmorphism {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: all 0.3s ease;\n}\n\n.kpi-card.glassmorphism:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(90, 175, 154, 0.3);\n  transform: translateY(-2px);\n}\n\n.kpi-card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.kpi-card-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n}\n\n.kpi-card-icon-wrapper svg {\n  font-size: 20px;\n}\n\n.icon-total {\n  background-color: rgba(90, 175, 154, 0.15);\n  color: #5AAF9A;\n}\n\n.icon-escrow {\n  background-color: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n}\n\n.icon-stripe {\n  background-color: rgba(99, 91, 255, 0.15);\n  color: #635bff;\n}\n\n.icon-affiliate {\n  background-color: rgba(156, 39, 176, 0.15);\n  color: #ba68c8;\n}\n\n.wallet-cards-grid--4 {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.wallet-card-tag-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.wallet-badge-pill {\n  font-size: 11px;\n  font-weight: 600;\n  color: #48d1cc;\n  background: rgba(72, 209, 204, 0.08);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  padding: 3px 8px;\n  border-radius: 12px;\n}\n\n.kpi-card-label {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.kpi-card-value {\n  font-size: 26px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.kpi-card-desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n  margin: 0;\n}\n\n.stripe-balance-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 8px;\n  margin-top: 4px;\n}\n\n.stripe-pending {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* Ledger Section */\n.ledger-section.glassmorphism {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 24px;\n  margin-top: 10px;\n}\n\n.ledger-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  padding-bottom: 12px;\n}\n\n.ledger-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #5AAF9A;\n  margin: 0;\n}\n\n.ledger-count {\n  font-size: 12px;\n  background-color: rgba(90, 175, 154, 0.1);\n  border: 1px solid rgba(90, 175, 154, 0.2);\n  color: #5AAF9A;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n/* Ledger Table */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.ledger-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n  text-align: left;\n}\n\n.ledger-table th {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 600;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(90, 175, 154, 0.15);\n  background-color: rgba(90, 175, 154, 0.04);\n}\n\n.ledger-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  vertical-align: middle;\n}\n\n.ledger-table th:first-child,\n.ledger-table td:first-child {\n  white-space: nowrap;\n  width: 120px;\n}\n\n.ledger-row {\n  transition: background-color 0.2s ease;\n}\n\n.ledger-row:hover {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n.ledger-offering-title {\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.ledger-booking-id {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 2px;\n}\n\n/* Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 11.5px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.ledger-status-icon {\n  font-size: 13px !important;\n}\n\n.status-released {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.2);\n}\n\n.status-escrow {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.2);\n}\n\n.status-disputed {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\n.status-refunded {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.status-unpaid {\n  background-color: rgba(255, 255, 255, 0.03);\n  color: rgba(255, 255, 255, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n/* Countdown Visualizer */\n.countdown-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ffc107;\n}\n\n.countdown-icon {\n  font-size: 14px !important;\n}\n\n.countdown-text {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Pagination */\n.ledger-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.pagination-btn {\n  background-color: transparent;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Loader Styles */\n.wallet-loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  gap: 12px;\n}\n\n.loader-spinner {\n  color: #5AAF9A !important;\n}\n\n.empty-table-row {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: italic;\n  padding: 30px !important;\n}\n\n.text-success { color: #28a745; }\n.text-warning { color: #ffc107; }\n.text-danger { color: #dc3545; }\n.text-muted { color: rgba(255, 255, 255, 0.6); }\n.font-semibold { font-weight: 500; }\n.font-bold { font-weight: 700; }\n\n.animate-fade-in {\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Earnings Trend SVG Chart */\n.earnings-chart-container {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 24px;\n  margin-top: 10px;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  padding-bottom: 12px;\n}\n\n.chart-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #5AAF9A;\n  margin: 0;\n}\n\n.chart-subtitle {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.empty-chart-state {\n  text-align: center;\n  padding: 40px;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: italic;\n}\n\n.svg-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  padding-top: 10px;\n}\n\n.earnings-svg {\n  width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n.chart-point-group {\n  cursor: pointer;\n}\n\n.chart-point-group:hover circle:first-child {\n  fill: #5AAF9A;\n  r: 5;\n}\n\n.chart-point-group:hover .point-pulse {\n  animation: pulse 1.2s infinite ease-out;\n  opacity: 0.4;\n}\n\n.chart-point-group:hover .point-tooltip {\n  opacity: 1;\n}\n\n.point-tooltip {\n  font-size: 9px;\n  font-weight: 600;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.chart-axis-label {\n  font-size: 9px;\n  font-weight: 500;\n}\n\n@keyframes pulse {\n  0% {\n    r: 6;\n    opacity: 0.5;\n  }\n  100% {\n    r: 16;\n    opacity: 0;\n  }\n}\n\n/* ── Unified Ledger Type Badges ── */\n.ledger-type-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n.type-service {\n  color: #48d1cc;\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n}\n.type-affiliate {\n  color: #ba68c8;\n  background: rgba(186, 104, 200, 0.12);\n  border: 1px solid rgba(186, 104, 200, 0.25);\n}\n\n/* ── Unified Affiliate Tab Styling ── */\n.affiliate-unified-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.affiliate-avatar-box {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.affiliate-avatar-img,\n.affiliate-avatar-initials {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.affiliate-avatar-initials {\n  background: #3bb3ae;\n  color: #071414;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.affiliate-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 4px 0;\n}\n\n.affiliate-tag {\n  font-size: 12px;\n  font-weight: 600;\n  color: #48d1cc;\n  background: rgba(72, 209, 204, 0.1);\n  padding: 3px 10px;\n  border-radius: 12px;\n}\n\n.affiliate-quick-stats {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.affiliate-stat-pill {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 12px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.affiliate-stat-pill span {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.affiliate-stat-pill strong {\n  font-size: 20px;\n  font-weight: 700;\n  color: #28a745;\n}\n\n/* ── Referral Sharing Boxes ── */\n.affiliate-sharing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.affiliate-box {\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.affiliate-box h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.affiliate-box p {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0 0 8px 0;\n  line-height: 1.5;\n}\n\n.affiliate-copy-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.affiliate-input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: #ffffff;\n  font-size: 13px;\n  outline: none;\n}\n\n.affiliate-copy-btn {\n  background: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.affiliate-copy-btn:hover {\n  background: #48d1cc;\n}\n\n/* ── Unified Payout Note ── */\n.affiliate-payout-note {\n  padding: 22px;\n  background-color: rgba(72, 209, 204, 0.05);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-left: 4px solid #48d1cc;\n  border-radius: 12px;\n}\n\n.affiliate-payout-note__content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.affiliate-payout-note__content h4 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #48d1cc;\n  margin: 0 0 6px 0;\n}\n\n.affiliate-payout-note__content p {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.75);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 680px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
